import { usePropertyField } from '../usePropertyField';
import { IApplicationRental } from '@apply/api/src/api/ApplyApi';

// ─── Rental – Core ────────────────────────────────────────────────────────────

export const usePropertyRentalPurchaseDate = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.rental?.purchaseDate,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), purchaseDate: v } as IApplicationRental })
    );

export const usePropertyRentalYearBuilt = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => {
            const y = p.rental?.yearBuilt;
            return y === 0 ? undefined : y;
        },
        (p, v) => ({
            ...p,
            rental: {
                ...(p.rental ?? {}),
                yearBuilt: v,
            } as IApplicationRental,
        })
    );

export const usePropertyRentalTargetLoanRequest = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.rental?.targetLoanRequest,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), targetLoanRequest: v } as IApplicationRental })
    );

export const usePropertyRentalPreferredTerm = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.rental?.preferredTermType,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), preferredTermType: v } as IApplicationRental })
    );

export const usePropertyRentalMonthsToAccessFunding = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.rental?.monthsToAccessFunding,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), monthsToAccessFunding: v } as IApplicationRental })
    );

export const usePropertyRentalBuildType = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.rental?.buildType,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), buildType: v } as IApplicationRental })
    );

export const usePropertyRentalCurrentDebt = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.rental?.currentDebt,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), currentDebt: v } as IApplicationRental })
    );
